import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Download } from "lucide-react";
import { subscribeNewsletter } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const STORAGE_KEY = "gls_exit_intent_shown_v1";
const LEAD_MAGNET_URL = "/api/static/assets/c9e578ba_6rpbg1xu_PACT_From-Conflict-to-Connection-Leadership-Guide.pdf";

const ExitIntentModal = () => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    const onLeave = (e) => {
      if (e.clientY <= 0 && !sessionStorage.getItem(STORAGE_KEY)) {
        sessionStorage.setItem(STORAGE_KEY, "1");
        setOpen(true);
      }
    };
    const t = setTimeout(() => document.addEventListener("mouseleave", onLeave), 4000);
    return () => { clearTimeout(t); document.removeEventListener("mouseleave", onLeave); };
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await subscribeNewsletter({ email });
      setOpen(false);
      window.open(LEAD_MAGNET_URL, "_blank", "noopener");
      navigate("/thank-you");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="exit-intent-modal" className="max-w-lg p-0 overflow-hidden border-[#E8DCDD]">
        <div className="bg-[#8C4A57] text-white px-8 py-6">
          <div className="inline-flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase bg-white/10 border border-white/20 rounded-sm px-3 py-1 mb-3">
            <Download className="w-3 h-3" /> Wait — one thing before you go
          </div>
          <h3 className="font-serif text-2xl font-semibold leading-tight">Take Leadership Philosophy Vol. 1 with you</h3>
        </div>
        <div className="p-8">
          <p className="text-sm text-[#6B5E62] leading-relaxed mb-5">
            A free preview from Dr. Andrew Campbell — the values, beliefs, and guiding principles
            that shape executive decision-making. Drop your email and we'll send it to you now.
          </p>
          <form onSubmit={submit} className="space-y-3" data-testid="exit-intent-form">
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="exit-intent-email" placeholder="you@example.com"
              className="w-full px-4 py-3 bg-[#FAF4F5] border border-[#E8DCDD] rounded-sm focus:ring-2 focus:ring-[#D9C5C9] focus:outline-none text-sm" />
            <button type="submit" disabled={loading} data-testid="exit-intent-submit"
              className="w-full bg-[#8C4A57] text-white hover:bg-[#703B45] py-3 rounded-sm text-sm font-semibold uppercase tracking-wide transition-colors duration-200 disabled:opacity-60">
              {loading ? "Sending..." : "Send me the guide"}
            </button>
          </form>
          <button onClick={() => setOpen(false)} data-testid="exit-intent-dismiss"
            className="mt-4 w-full text-xs text-[#6B5E62] uppercase tracking-wider hover:text-[#8C4A57]">
            No thanks, continue browsing
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ExitIntentModal;
